import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { isErrorResponse } from '../../utils/error-handlers';
import { TRANSACTION_ENDPOINT } from '../../config/endpoints';
import {
  CLEAR_TRANSACTION,
  CLEAR_TRANSACTIONS,
  FLAG_TRANSACTION_ACTIVITY,
  FLAG_GETTING_TRANSACTIONS,
  GET_TRANSACTION,
  GET_TRANSACTIONS,
} from '../types';
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';

const flagGettingTransactions = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TRANSACTIONS,
    payload: flag,
  });

const getTransactions = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingTransactions(true));
    const query = tableFilters;
    const url = `${TRANSACTION_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const transactions = await response.json();
    dispatch({
      type: GET_TRANSACTIONS,
      payload: transactions,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingTransactions(false));
  }
};

const clearTransactions = () => (dispatch) =>
  dispatch({
    type: CLEAR_TRANSACTIONS,
  });

const flagTransactionActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TRANSACTION_ACTIVITY,
    payload: flag,
  });

const getTransaction =
  async ({ transactionId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTransactionActivity(true));
      const url = `${TRANSACTION_ENDPOINT}/${transactionId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const transaction = await response.json();
      dispatch({
        type: GET_TRANSACTION,
        payload: transaction,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagTransactionActivity(false));
    }
  };

const clearTransaction = () => (dispatch) =>
  dispatch({
    type: CLEAR_TRANSACTION,
  });


  export {
  flagGettingTransactions,
  getTransactions,
  clearTransactions,
  getTransaction,
  clearTransaction,
};
